import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  actions,
  CellProps,
  HeaderGroup,
  TableOptions,
  Row,
  TableState,
  useFlexLayout,
  useFilters,
  useRowSelect,
  useSortBy,
  useTable,
  ActionType,
  TableInstance,
  useExpanded,
  usePagination,
} from "react-table";

import {
  ColumnDescription,
  CustomToolbarItem,
  FilterRenderer,
  useToolbarPopupContext,
} from "@itwin/components-react";
import { Button, Select } from "@itwin/itwinui-react";
import { cRealityData } from "./RealityData";
import { cIndex } from "./RMIndex";
import { ViewAttributesStatusField } from "@itwin/appui-react";
import { ViewSelector } from "@itwin/appui-react";
import { Table } from "@itwin/itwinui-react";
import { ContextRealityModelProps } from "@itwin/core-common";
import { cRealityDataApi } from "./RealityDataApi";
import { cUserManager } from "./UserManager";
import { OperationsBase } from "@itwin/imodels-client-management";

type TableDataTemplate = { RealityDataName: string };

let selectedRows: any = [];
let previousOptions: any = [];

var tableState: TableState<TableDataTemplate>;

const parentModels: string[] = []; 

export function RMSelectPanel() {
  const [rModel, setRModel] = useState("");
  const [_name, setRMMap] = useState(new Map<string, string>());

  const { closePanel } = useToolbarPopupContext();

  const columns: ColumnDescription[] = [];
  columns.push({
    key: "RealityModels",
    label: "Reality Models",
    width: 200,
  });

  const onMultiSelect = async (option, state?: TableState<TableDataTemplate>) => {
    let detach: boolean = true;
    //const [detach, setDetach] = useState(true);
    if (state) {
      // TODO: CASE 0: NEW PARENT NEW CHILD
      const regex = /[.]/;

      const newChild = Object.keys(state.selectedRowIds).filter(key => key.match(regex));
      const newParent = Object.keys(state.selectedRowIds).filter(key => !key.match(regex));

      if (newChild.length !== 0 && newParent.length !== 0) {
        const keys = Object.keys(state.selectedRowIds);
          keys.forEach(entry => {
            if (regex.test(entry)) {
              delete state.selectedRowIds[entry];
            }
          });
        option = option.filter(model => parentModels.includes(model.RealityModels));
        //setDetach(true);
        detach = true;
      }

      if (tableState) {
        const previousStateKeys = Object.keys(tableState.selectedRowIds);
 
        if (previousStateKeys.length !== 0) { 
          const oldChild = previousStateKeys.filter(key => key.match(regex));
          const oldParent = previousStateKeys.filter(key => !key.match(regex));
          // TODO- CASE 1: OLD PARENT NEW PARENT
          // Delete the Old Parent
          // -- WORKING -- MARKED COMPLETE
          if (oldChild.length === 0 && newChild.length === 0) {
            delete state.selectedRowIds[previousStateKeys[0]];
            option.splice(parseInt(previousStateKeys[0]),1);
           // setDetach(true);
            detach = true;
          }

          // TODO- CASE 2: OLD PARENT NEW CHILD
          // Delete the Old Parent and Retain the new Child
          // -- WORKING -- MARKED COMPLETE
          else if (oldChild.length === 0 && newChild.length !== 0) {
            delete state.selectedRowIds[previousStateKeys[0]];
            option = option.splice(parseInt(previousStateKeys[0]),1);
            //setDetach(true);
            detach = true;
          }

          // TODO- CASE 3: OLD CHILD NEW PARENT
          // Delete the Old CHILD and Retain the new PARENT
          // -- WORKING -- MARKED COMPLETE
          else if (oldChild.length !== 0 && newParent.length !== 0) {
            delete state.selectedRowIds[previousStateKeys[0]];
            option = option.filter(model => parentModels.includes(model.RealityModels));
            //setDetach(true);
            detach = true;
          }

          // TODO- CASE 4: OLD CHILD NEW CHILD
          // Show Both Child
          else if (oldChild.length !== 0 && newChild.length !== 0) {
            //setDetach(false);
            detach = false;
          }
        }
      }
      if (Object.keys(state.selectedRowIds).length > selectedRows.length) {
        selectedRows = Object.keys(state.selectedRowIds);
      }
      //case for deselect
      else if (Object.keys(state.selectedRowIds).length < selectedRows.length) {
        var difference = selectedRows.filter(
          (x) => !Object.keys(state.selectedRowIds).includes(x)
        );
        cIndex.deselectById(Number(difference[0]));
        selectedRows = Object.keys(state.selectedRowIds);
      }
    }
    const realityMap = cUserManager.getRealityModelsMap();
    for (const value of option) {
      const model = realityMap.find(model => model.get("Label") === value.RealityModels);
      const rm = model?.get("Name") as string;
     // const rm = value.RealityModels;
      if (rm === "Cross_Grid") {
        cIndex.setIndexModel("Cross_Grid");
      }
       else if (rm === "Central_Index") {
        cIndex.setIndexModel("Central_Index");
      } 
      else if (rm === "Central_2") {
        cIndex.setSelectedModel(rm, detach, "$Elements");

        setRModel(rm);
      }
      else {
        console.log(rModel);
        cIndex.setSelectedModel(rm, detach, "$Elements");
      }
      setRModel(rm);
    }
    onSelect(option, state);

    if (option.length < previousOptions.length) {
      const deselectedModel = previousOptions.filter(prevModel => !option.some(newModel => 
        prevModel.RealityModels === newModel.RealityModels));
      console.log(deselectedModel);
      for (const value of deselectedModel) {
        const model = realityMap.find(model => model.get("Label") === value.RealityModels);
        const rm = model?.get("Name") as string;
        cIndex.deselectByName(rm);
      }
    }
    previousOptions = option;
  };

  const [itemProps, setItemProps] = useState<ContextRealityModelProps[]>([]);

  useEffect(() => {
    console.log("in getItemProps");
    const realityModels = cRealityData.getRealityModels();
    if (realityModels) {
      setItemProps(realityModels);
    }
  }, [itemProps]);

  const makeTableData = () => {
    const realityMap = cUserManager.getRealityModelsMap();
    const modelNames = realityMap.map(val => val.get("Name"));
    let realityData: any[] = [];
    for (let i = 0; i < realityMap.length; i++) {
      const row = {
        RealityModels: realityMap[i].get("Label"), // Central
        subRows: [] //[Skid 1704, Skid 1502]
      };
      realityData.push(row);
    }
  
    //Find ChildModels
    const redundantIndexes: any = [];
    for (let i = 0; i < realityMap.length; i++) {
      // Adding Children to the Parent Model
      if (realityMap[i].get("ParentModel") !== "") {
        const index = modelNames.indexOf(realityMap[i].get("ParentModel")); // Parent Model Index
        const subRow = {
          RealityModels: realityMap[i].get("Label") // Skid 1203
        };
        if (realityData[index].subRows !== undefined) {
          realityData[index].subRows.push(subRow); 
          redundantIndexes.push(i); //pushing child models to array
        }
      }
      else {
        if (!parentModels.includes(realityMap[i].get("Label") as string))
          parentModels.push(realityMap[i].get("Label") as string);
      }
    }

    //Removing child models
    realityData = realityData.filter(item => !redundantIndexes.includes(realityData.indexOf(item)));
 

    return realityData;
  };

  const Columns = React.useMemo(
    () => [
      {
        Header: "Reality Models",
        columns: [
          {
            id: "RealityModels",
            Header: "Reality Models",
            accessor: "RealityModels",
            width: 200,
          },
        ],
      },
    ],
    []
  );

  const _getData = useCallback(makeTableData, [itemProps]);

  const data = useMemo((): TableDataTemplate[] => _getData(), [_getData]);

  const onSelect = useCallback(
    (selectedData: TableDataTemplate[] | undefined, state?: TableState<TableDataTemplate>) => {
      // tableState.current = state;
      if (state) tableState = state;
    },
    []
  );
  return (
    <div
      style={{
        height: "70px",
        padding: "3px",
        boxSizing: "border-box",
      }}
    >
      <Table
        data={data}
        columns={Columns}
        emptyTableContent="No data."
        isLoading={false}
        styleType="zebra-rows"
        density="extra-condensed"
        isSelectable={true}
        onSelect={onMultiSelect}
        initialState={tableState}
        style={{ maxHeight: 300 }}
      />
    </div>
  );
}

export class cRMSelect {
  public static popupRMSelectButton(priority: number): CustomToolbarItem {
    const button: CustomToolbarItem = {
      isCustom: true,
      id: "selectRM",
      itemPriority: priority,
      icon: "icon-isolate",
      isActive: true,
      label: "Select Model",
      panelContentNode: cRMSelect.rmSelectPanel(),
    };

    return button;
  }

  private static rmSelectPanel(): React.ReactNode {
    return <RMSelectPanel />;
  }
}



